import { FC } from 'react'
import { getProfissionalVinculo } from '../../core/_requests'
import { ProfissionalDeSaudeVinculoModal } from '../../components/modal/ProfissionalDeSaudeVinculoModal'
import { ProfissionalDeSaudeVinculoEmpresasModal } from '../../components/modal/ProfissionalDeSaudeVinculoEmpresasModal'
import { ProfissionalDeSaudeModal } from '../../components/modal/ProfissionalDeSaudeModal'
import { useT } from '_metronic/i18n/Metronici18n'
import { RowActions, useModal } from 'app/components'
import { IconPaths, ModalSize } from '_metronic/helpers'
import { CertificadoUpload } from 'app/modules/apps/funcionarios/funcionarios-list/components/modal/CertificadoUpload'
import { getEnderecosByPessoaId, getUsuarioByPessoaId } from 'app/modules/auth/core/_requests'
import { PessoaList } from 'app/modules/auth'

type Props = {
  profissional: PessoaList
}

export const ProfissionalDeSaudeActionsCell: FC<Props> = ({ profissional }) => {
  const { showModal } = useModal()
  const { t } = useT()
  const pessoaId = profissional.id

  const editProfissional = () =>
    showModal({
      title: 'Editar Profissional de Saúde',
      content: <ProfissionalDeSaudeModal />,
      fetchers: {
        usuario: () => getUsuarioByPessoaId(pessoaId),
        endereco: async () => {
          const data = await getEnderecosByPessoaId(pessoaId)
          return data[0]
        },
      },
    })

  const editEspecialidades = () =>
    showModal({
      title: 'Editar Especialidades dos Vínculos',
      content: <ProfissionalDeSaudeVinculoModal />,
      size: ModalSize.ExtraLarge,
      fetchers: {
        profissional: () => getProfissionalVinculo(pessoaId),
      },
    })

  const editEmpresas = () =>
    showModal({
      title: `Editar ${t('empresa.plural')} Vinculadas`,
      content: <ProfissionalDeSaudeVinculoEmpresasModal />,
      fetchers: {
        usuario: () => getUsuarioByPessoaId(pessoaId),
      },
    })

  const openCertificado = () =>
    showModal({
      title: 'Informar Certificado',
      content: <CertificadoUpload />,
      size: ModalSize.ExtraLarge,
      fetchers: {
        usuario: () => getUsuarioByPessoaId(pessoaId),
      },
    })

  return (
    <RowActions
      itemName={profissional.nomeSocial || profissional.nome || 'profissional'}
      primaryAction={{ label: 'Editar', onClick: editProfissional, icon: IconPaths.Pen }}
      items={[
        { label: 'Especialidades dos vínculos', onClick: editEspecialidades },
        { label: `${t('empresa.plural')} vinculadas`, onClick: editEmpresas },
        { label: 'Certificado digital', onClick: openCertificado },
      ]}
    />
  )
}
